import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router'
import constants from 'constants';

const {
  EXPORT_WEBINARS_CSV,
} = constants;

function Tools({
  count,
  deleteWebinars
}) {
  return (
    <div className="admin_list">
      <h5>Webinars (<span>{count}</span>)</h5>
      <Link className="button_classic" to="/webinars/new">Add webinar</Link>
      <a className="button_classic" href={EXPORT_WEBINARS_CSV} target="_blank">
        Export webinar details
      </a>
      <a className="button_delete" onClick={deleteWebinars}>Delete</a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/Webinar/Toolbar/Tools.jsx